import { __assign, __rest } from "tslib";
import React from 'react';
export var SeriesIcon = React.forwardRef(function (_a, ref) {
    var color = _a.color, className = _a.className, restProps = __rest(_a, ["color", "className"]);
    var styles = {
        backgroundColor: color,
        width: '14px',
        height: '4px',
        borderRadius: '1px',
        display: 'inline-block',
        marginRight: '8px',
    };
    return React.createElement("div", __assign({ ref: ref, className: className, style: styles }, restProps));
});
SeriesIcon.displayName = 'SeriesIcon';
//# sourceMappingURL=SeriesIcon.js.map